<!--
 * @Author: QWX
 * @Description:订单详情抽屉
 * @LastEditors: QWX
 * @LastEditTime: 2021-12-28 19:11:48
-->
<template>
  <el-drawer
    title="子订单详情"
    :visible.sync="drawer"
    v-if="drawer"
    size="900px"
    append-to-body
    class="order-detail"
    direction="rtl">
    <zl-saas-container v-loading="loading">
      <div class="order-oper-btn-box">
        <operRecord :id="id" />
      </div>
      <div class="order-info" >
        <img src="~@/assets/images/reconciliationAndSettlement/order-logo.svg" alt="">
        <h3>{{baseInfo.subOrderCode}}<span :class="['status-box', `status-${baseInfo.status}`]">{{getValue('subOrderStatus',baseInfo.status)}}</span></h3>
        <div>
          来源主订单编号：{{baseInfo.orderCode}}
          <el-divider direction="vertical"></el-divider>
          来源主订单：<el-button type="text" size="medium">{{baseInfo.orderName}}</el-button>
        </div>
        <div>
          主订单种类：{{baseInfo.orderName}}
          <el-divider direction="vertical"></el-divider>
          电子到货验收单：<el-link type="primary" @click="selectArrivalDialog">电子订单.pdf</el-link>
        </div>
        <div></div>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="货物信息" name="1">
          <span slot="label" class="self-tabs">货物信息</span>
          <div class="orderDetail-tabs-body" v-if="baseInfo.orderCode">
            <div class="orderDetail-m-b">
              <div  class=" m-b">
                <span class="saas-card-header-name">交货信息</span>
              </div>
              <el-descriptions   size="medium" :column="3">
                <el-descriptions-item label="供应商联系人">{{baseInfo.contactName}}</el-descriptions-item>
                <el-descriptions-item label="联系人电话">{{baseInfo.contactPhone}}</el-descriptions-item>
                <el-descriptions-item label="物流公司名称">{{baseInfo.logistics && baseInfo.logistics.corpName}}</el-descriptions-item>
                <el-descriptions-item label="物流单号">{{baseInfo.logistics && baseInfo.logistics.trackNumber}}</el-descriptions-item>
                <el-descriptions-item label="货物承运人">{{baseInfo.logistics && baseInfo.logistics.driverInfo}}</el-descriptions-item>
                <el-descriptions-item label="车辆信息">{{baseInfo.logistics && baseInfo.logistics.truckInfo}}</el-descriptions-item>
                <el-descriptions-item label="发货时间">{{baseInfo.startTime}}</el-descriptions-item>
                <el-descriptions-item label="预计到货时间">{{baseInfo.endTime}}</el-descriptions-item>
              </el-descriptions>
            </div>
            <div class="orderDetail-m-b">
              <div  class=" m-b">
                <span class="saas-card-header-name">货物清单</span>
              </div>
              <zl-server-page-table
                :border="false"
                ref="listDetailTable"
                :api="getApi"
                smallPagination
                paginationLayout="total, sizes, prev, pager, next, jumper"
              >
                <el-table-column
                  v-for="(row, index) in column"
                  :key="index"
                  :label="row.columnNameCH"
                  :prop="row.columnNameEN"
                >
                  <template slot-scope="scope">
                    {{scope.row[row.columnNameEN]}}
                  </template>
                </el-table-column>
              </zl-server-page-table>
              <div class="orderDetail-count">含税合计总价(元):<span class="money">{{baseInfo.budgetAmount | $zlFiltersMoneyFormat}} </span>元</div>

              <el-descriptions   size="medium" :column="1">
                <el-descriptions-item label="附件">{{baseInfo.fileId}}</el-descriptions-item>
                <el-descriptions-item label="备注">{{baseInfo.remark}}</el-descriptions-item>
              </el-descriptions>
            </div>
          </div>

        </el-tab-pane>
        <el-tab-pane label="退换货原因" name="2">
          <span slot="label" class="self-tabs">退换货原因</span>
          <div class="orderDetail-m-b orderDetail-tabs-body">
            <div  class=" m-b">
              <span class="saas-card-header-name">验收时退换货原因</span>
            </div>
            <div >
              <div class="m-b">
                <el-descriptions  title="退货" size="medium" :column="2">
                  <el-descriptions-item label="采购人原因">{{returnForm.cgrReasonTH}}</el-descriptions-item>
                  <el-descriptions-item label="供应商原因">{{returnForm.gysReasonTH}}</el-descriptions-item>
                </el-descriptions>
              </div>
              <div class="return-m-b">
                <el-descriptions  title="换货" size="medium" :column="2">
                  <el-descriptions-item label="采购人原因">{{returnForm.cgrReasonHH}}</el-descriptions-item>
                  <el-descriptions-item label="供应商原因">{{returnForm.gysReasonHH}}</el-descriptions-item>
                </el-descriptions>
              </div>
              <el-descriptions   size="medium" :column="1">
                <el-descriptions-item label="附件">{{returnForm.fileId}}</el-descriptions-item>
                <el-descriptions-item label="备注">{{returnForm.remark}}</el-descriptions-item>
              </el-descriptions>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="验收后退换货" name="3">
          <span slot="label" class="self-tabs">验收后退换货</span>
          <div class="orderDetail-tabs-body">
            <div class="orderDetail-m-b">
              <div  class="m-b">
                <span class="saas-card-header-name">验收后退换货记录</span>
              </div>
              <zl-server-page-table
                :border="false"
                showTotal
                ref="multipleTable"
                :api="acceptGetApi"
                :columns="acceptColumns"
              >
                <!-- template里面写的话会放到columns之后去渲染 -->
                <el-table-column fixed="right" label="操作" min-width="135">
                  <template slot-scope="scope">
                    <el-link type="primary" @click="skipThhDetail(scope.row)">
                      查看
                    </el-link>
                  </template>
                </el-table-column>
              </zl-server-page-table>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="对账结算记录" name="4">
          <span slot="label" class="self-tabs">对账结算记录</span>
          <div class="orderDetail-tabs-body">
            <div class="orderDetail-m-b">
              <div  class=" m-b">
                <span class="saas-card-header-name">对账结算记录</span>
              </div>
              <div class="settlement-records">
                对账结算单：<el-button type="text" size="medium">{{accountInfo.accountCode}}</el-button><i :class="['order-status', `status-${accountInfo.status}`]">{{getValue('reconciliationAndSettlementStatus', accountInfo.status)}}</i>
              </div>
              <div class="settlement-records finalCount">
                <span class="label">最终结算金额(元)：</span>
                <template v-for="(item, index) in accountMoney" >
                  <i class="divider" :key="index" v-if="index !== 0"></i>
                  <span class="rmb" :key="index">{{item.money | $zlFiltersMoneyFormat}}</span>{{item.currencyCh}}
                </template>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </zl-saas-container>
  </el-drawer>
</template>

<script>
import store from '@/store'
import dayjs from 'dayjs'
import { getValue } from '@/lib/enum'
import operRecord from '@/components/business/operRecord.vue'
import arrivalOrderCertDialog from '@/components/dialog/arrivalOrderCertDialog.vue'
export default {
  components: { operRecord },
  data() {
    return {
      getValue,
      drawer: false,
      activeName: '1',
      supplierList: [],
      returnList: [
        { status: 0 },
        { status: 1 },
        { status: 2 }
      ],
      baseInfo: {},
      column: [],
      id: '',
      returnForm: {
        cgrReasonTH: '', // 退货 采购人原因
        gysReasonTH: '', // 退货 供应商原因
        cgrOtherTH: '', // 退货 其他原因(采购人)
        gysOtherTH: '', // 退货 其他原因(供应商)
        cgrOtherHH: '', // 换货 其他原因(采购人)
        gysOtherHH: '', // 换货 其他原因(供应商)
        cgrReasonHH: '', // 换货 采购人原因
        gysReasonHH: '', // 换货 供应商原因
        fileId: '', // 附件
        remark: '' // 退换货说明
      },
      // 验收后退换货表头
      acceptColumns: [
        {
          label: '序号',
          prop: 'rowNum',
          width: '100px',
          align: 'center'
        },
        {
          label: '单号',
          prop: 'thhCode',
          minWidth: '100px',
          align: 'center'
        },
        {
          label: '类型',
          prop: 'thhType',
          minWidth: '100px',
          align: 'center',
          formatter: (row) => getValue('thhType', row.thhType)
        },
        {
          label: '金额(元)',
          prop: 'thAmount',
          minWidth: '100px',
          align: 'center',
          formatter: (row) => row.thAmount && this.$zl.util.splitK(row.thAmount)
        },
        {
          label: '提交时间',
          prop: 'submitTime',
          minWidth: '100px',
          align: 'center',
          formatter: (row) => row.submitTime && dayjs(row.submitTime).format('YYYY-MM-DD hh:mm:ss')
        },
        {
          label: '状态',
          prop: 'status',
          minWidth: '100px',
          align: 'center',
          formatter: (row) => getValue('thhStatus', row.status)
        }
      ],
      accountInfo: {},
      loading: false
    }
  },
  computed: {
    accountMoney() {
      // 合并相同币种 再展示
      const arr = []
      const map = new Map()
      this.accountInfo.accountMoney && this.accountInfo.accountMoney.map((p, index) => {
        if (map.has(p.currencyCh)) {
          arr[map.get(p.currencyCh)].money = this.$zl.util.add(arr[map.get(p.currencyCh)].money, p.money)
        } else {
          map.set(p.currencyCh, arr.length)
          arr.push(p)
        }
      })
      return arr
    }
  },
  methods: {
    open(id) {
      this.drawer = true
      this.id = id
      this.init()
    },
    async init() {
      await this.getDetail(this.id)
      this.getDdColumn()
      this.getAccountInfoBySubOrderId()
      this.getThhInfoMoment()
    },
    // 查看电子到货验收单
    selectArrivalDialog() {
      this.$zl.dialog.openFull(arrivalOrderCertDialog, {
        subOrderId: this.id,
        system: this.$store.state.system
      }).then((res) => {
      })
    },
    getDetail(id) {
      this.loading = true
      return store.dispatch('getSubOrderDetail', {
        id
      }).then(res => {
        this.loading = false
        this.baseInfo = { ...res }
      }).catch(() => {
        this.loading = false
      })
    },
    // 获取订单清单表头
    getDdColumn() {
      store.dispatch('getDdColumnZS', {
        unionId: this.baseInfo.orderId
      }).then(res => {
        // 初始表头
        const listColumns = JSON.parse(res.colValue || '[]')
        if (listColumns.length) {
          // 过滤出采购数量的数据
          const amountArr = listColumns.filter(val => val.columnNameEN === 'amount')
          const amountSeq = amountArr[0].seq
          // 在表头添加‘已发货数量’
          const data = {
            columnNameCH: '发货数量',
            columnNameEN: 'deliverSize',
            seq: amountArr[0].seq + 1
          }

          // 在采购数量后面添加‘已发货数量’
          // 退换货页面不需要
          if (this.pageType !== 'return') {
            listColumns.splice(amountSeq + 1, 0, data)
          }

          // 在最新的表头后面添加‘到货数量’，‘验收数量’，‘退货数量’，‘换货数量’
          const length = listColumns.length
          const arrivalSize = {
            columnNameCH: '到货数量',
            columnNameEN: 'arrivalSize',
            isEdit: true, // 可编辑
            seq: length
          }
          let checkSize = {
            columnNameCH: '验收数量',
            columnNameEN: 'checkSize',
            isEdit: true, // 可编辑
            seq: length + 1
          }
          const returnSize = {
            columnNameCH: '退货数量',
            columnNameEN: 'returnSize',
            isEdit: true, // 可编辑
            seq: length + 2
          }
          const barterSize = {
            columnNameCH: '换货数量',
            columnNameEN: 'barterSize',
            isEdit: true, // 可编辑
            seq: length + 3
          }
          const exchangeSize = {
            columnNameCH: '可退换货数量',
            columnNameEN: 'exchangeSize',
            seq: length + 3
          }
          listColumns.push(arrivalSize, checkSize, returnSize, barterSize)

          this.column = listColumns
        }
      })
    },
    getApi(args) {
      // 验收、查看
      return store.dispatch('pageAllZddInventorySubOrder', {
        subOrderId: this.id
      }).then(res => {
        return {
          rows: res.map(
            (t, idx) => {
              t.rowValue = t.rowValue && JSON.parse(t.rowValue) || {}
              t.rowValue.id = t.id
              t.rowValue.checkSize = t.checkSize
              t.rowValue.deliverSize = t.checkSize ? t.deliverSize ? t.deliverSize : 0 : '-'
              t.rowValue.arrivalSize = t.checkSize ? t.arrivalSize ? t.arrivalSize : 0 : '-'
              t.rowValue.returnSize = t.checkSize ? t.returnSize ? t.returnSize : 0 : '-'
              t.rowValue.barterSize = t.checkSize ? t.barterSize ? t.barterSize : 0 : '-'
              return t.rowValue
            }
          ),
          total: res.totalCount
        }
      })
    },
    // 获取验收时的退换货
    getThhInfoMoment() {
      store.dispatch('pageSubOrderTHHMoment', {
        subOrderId: this.id
      }).then(res => {
        // 有退货
        if (res.th) {
          this.hasTh = true
          this.returnForm.cgrReasonTH = res.th.cgrReason
          this.returnForm.gysReasonTH = res.th.gysReason
          this.returnForm.cgrOtherTH = res.th.cgrOther
          this.returnForm.gysOtherTH = res.th.gysOther
        }
        // 有换货
        if (res.hh) {
          this.hasHh = true
          this.returnForm.cgrReasonHH = res.hh.cgrReason
          this.returnForm.gysReasonHH = res.hh.gysReason
          this.returnForm.cgrOtherHH = res.hh.cgrOther
          this.returnForm.gysOtherHH = res.hh.gysOther
        }
        this.returnForm.fileId = (res.th && res.th.fileId) || (res.hh && res.hh.fileId)
        this.returnForm.remark = (res.th && res.th.remark) || (res.hh && res.hh.remark)
        console.log('093120390912381238123', res)
        console.log('qewwqeqweqew', this.returnForm)
      })
    },
    /**
     * @description: 验收后退换货详情
     * @param {*} args
     */
    acceptGetApi(args) {
      return store.dispatch('pageSubOrderTHHAfter', {
        subOrderId: this.id,
        pageNum: args.page,
        pageSize: args.size
      }).then((res) => {
        console.log('res', res)
        return {
          rows:
            // 后端可能返回null
            (res.list || []).map((t, index) => ({
              ...t,
              // 后端不提供行号,此处手动计算
              rowNum: args.size * (args.page - 1) + index + 1
            })) || [],
          total: res.totalCount
        }
      })
    },
    // 获取对账结算记录
    getAccountInfoBySubOrderId() {
      store.dispatch('getListAccountBySubOrderId', {
        subOrderId: this.id
      }).then(res => {
        if (res && res.length) {
          this.accountInfo = {
            accountCode: res[0].accountCode,
            accountMoney: JSON.parse(res[0].accountMoney || '[]'),
            status: res[0].status,
            id: res[0].status
          }
        }
      })
    },
    // 跳至退换货详情页
    skipThhDetail(obj) {
      this.$router.push({ name: `${this.$store.state.system === 'purchaser' ? 'ReturnDetail' : 'SupplierReturnDetail'}`, query: { id: obj.id, type: obj.thhType === 10 ? 'return' : 'exchange', hasBtn: false } })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/reconciliationAndSettlement.scss';
::v-deep.zl-saas-contianer .saas-contianer-main__contant{
  padding: 0 !important;
}

.order-detail .el-card{
  border: none;
  box-shadow: none;
}
.order-oper-btn-box{
  position: absolute;
  right: 6px;
  top: 16px;
}
</style>
